import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { PutPreferencesPartialRequest } from './types/put-preferences-partial.type';

export const putPreferencesPartial = async (
    payload: PutPreferencesPartialRequest
): Promise<AxiosResponse<void>> => {
    const { id, token, preferences } = payload;

    const preferencesIds = preferences
        .filter((preference) => preference.isSelected)
        .map((preference) => preference.id);

    const apiUrl = `/account/subscriptions/partial?id=${id}&token=${token}`;

    const response = await api.put(apiUrl, {
        selectedSubscriptions: preferencesIds,
    });

    return response;
};
